module.exports = __webpack_public_path__ + "img/Group 427320722@2x.30a19cc6.png";